import { useState } from "react";
import { Flag } from "lucide-react";
import { api, errorMessage } from "../lib/api";
import { useT } from "../i18n";

const REASONS = ["fake_profile", "inappropriate", "harassment", "spam", "other"];

export const ReportProfile = ({ profileId }) => {
  const { t } = useT();
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [details, setDetails] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/reports", { profile_id: profileId, reason, details: details || null });
      setSent(true);
      setOpen(false);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  if (sent) return <p data-testid="report-sent" className="mt-8 text-center text-xs text-rox-muted">{t("report_sent")}</p>;
  if (!open) {
    return (
      <button data-testid="report-profile-button" onClick={() => setOpen(true)} className="mt-8 flex w-full items-center justify-center gap-2 py-2 text-xs font-semibold uppercase tracking-[0.16em] text-rox-muted transition-colors hover:text-rox-orange">
        <Flag size={14} /> {t("report_profile")}
      </button>
    );
  }
  return (
    <form onSubmit={submit} className="panel mt-8 space-y-3 p-4" data-testid="report-form">
      <p className="h-display text-2xl">{t("report_profile")}</p>
      <select data-testid="report-reason" className="field appearance-none" value={reason} onChange={(e) => setReason(e.target.value)} required>
        <option value="" disabled>{t("report_reason")}</option>
        {REASONS.map((r) => <option key={r} value={r}>{t(`reason_${r}`)}</option>)}
      </select>
      <textarea data-testid="report-details" className="field min-h-[72px]" placeholder={t("report_details")} value={details} onChange={(e) => setDetails(e.target.value)} maxLength={300} />
      {error && <p data-testid="report-error" className="text-sm text-rox-orange">{error}</p>}
      <div className="flex gap-2">
        <button type="button" data-testid="report-cancel" onClick={() => setOpen(false)} className="btn-ghost flex-1 py-3 text-sm">{t("cancel")}</button>
        <button data-testid="report-submit" disabled={busy || !reason} className="btn-primary flex-1 py-3 text-sm">{t("report_send")}</button>
      </div>
    </form>
  );
};
